import { Box } from '@mui/material';
import React, { useState, useEffect, useRef, memo } from 'react';
//@ts-ignore
import exitIntent from 'exit-intent';

import useAuth from '@utils/useAuth';
import ExitIntentModal from '@components/ExitIntentModal';

interface IExitIntent {
  isMobileNotVisible?: boolean;
  isAutoShowOnFiveSec?: boolean;
}

const ExitIntent = ({
  isMobileNotVisible = false,
  isAutoShowOnFiveSec = false,
}: IExitIntent) => {
  const [showPopup, setShowPopup] = useState(false);

  const timeoutRef = useRef<any>();

  const { authState, detectedCountryCode: countryDetected } = useAuth();

  const getExitIntentShow = localStorage.getItem('exit_intent_show')
    ? JSON.parse(localStorage.getItem('exit_intent_show') || '')
    : {};

  const today = new Date().getTime();

  const milisecondsInOneDay = 24 * 60 * 60 * 1000;

  const renderCondition =
    getExitIntentShow && getExitIntentShow?.time
      ? today >
        new Date(getExitIntentShow?.time).getTime() + milisecondsInOneDay * 7
      : true;

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    const removeExitIntent = exitIntent({
      threshold: 1,
      eventThrottle: 300,
      onExitIntent: () => {
        renderCondition && !authState?.token && setShowPopup(true);
      },
    });

    timeoutRef.current =
      renderCondition &&
      !authState?.token &&
      isAutoShowOnFiveSec &&
      setTimeout(() => {
        setShowPopup(true);
      }, 5000);

    return () => {
      removeExitIntent(renderCondition || !authState?.token);
    };
  }, [renderCondition, authState]);

  useEffect(() => {
    if (showPopup) {
      resetTimeout();
      localStorage.setItem(
        'exit_intent_show',
        JSON.stringify({ value: true, time: new Date() })
      );
    }
  }, [showPopup]);

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    <Box>
      {showPopup ? (
        <ExitIntentModal
          open={showPopup}
          handleClose={handleClose}
          isMobileNotVisible={isMobileNotVisible}
          countryCode={countryDetected}
        />
      ) : null}
    </Box>
  );
};

export default memo(ExitIntent);
